import React, { useState } from 'react';
import InfoBulle from './Info.js';

const QuotientFamilialCalculator = () => {
  const [resources, setResources] = useState(0);
  const [prestations, setPrestations] = useState(0);
  const [children, setChildren] = useState(0);
  const [handicappedChildren, setHandicappedChildren] = useState(0);
  const [quotient, setQuotient] = useState(null);

  const calculateQuotient = () => {
    let parts = 2.5;
    if (children > 1) {
      parts = 3 + Math.max(0, children - 2) + handicappedChildren * 0.5;
    }
    const total = (resources / 12) + prestations;
    let qf = total / parts;

    setQuotient(qf.toFixed(2));
  };

  return (
    <div className="calculator">
      <label>
        Revenu fiscal de référence de l’ensemble du foyer <InfoBulle message="Saisissez le total des revenus fiscaux de référence de votre foyer. Si vous vivez en couple et que vous faites une déclaration séparée, additionnez les 2 RFR."/>
        <input type="number" value={resources} onChange={e => setResources(Number(e.target.value))} />
      </label>
      <label>
        Prestations familiales du mois en cours <InfoBulle message="Indiquez le montant des prestations familiales perçues de façon régulière, comme l’aide au logement ou les allocations familiales. 

Les aides perçues de façon ponctuelle, comme l’allocation de rentrée scolaire, ne sont pas à indiquer.
" />
        <input type="number" value={prestations} onChange={e => setPrestations(Number(e.target.value))} />
      </label>
      <label>
        Nombre d’enfants à charge
        <input type="number" value={children} onChange={e => setChildren(Number(e.target.value))} />
      </label>
      <label>
        Nombre d'enfants handicapés
        <input type="number" value={handicappedChildren} onChange={e => setHandicappedChildren(Number(e.target.value))} />
      </label>
      <div className="button-container">
        <button onClick={calculateQuotient}>Calculer</button>
      </div>
      <div className="resultat" >{quotient !== null && <p>Quotient familial: {quotient}</p>}</div>
    </div>
  );
};

export default QuotientFamilialCalculator;
